#import "../ApprovalsListFields.graphql"
query Approvals(
  $first: Int
  $after: Cursor
  $orderBy: [ApprovalsOrderBy!]
  $filter: ApprovalFilter
) {
  approvals(first: $first, after: $after, orderBy: $orderBy, filter: $filter) {
    nodes {
      ...ApprovalsListFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
  }
}
